// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import commonJs from './public/common'
import ajax from './public/ajax'
import filters from './public/filters';//过滤器
import '../static/css/common.css'
import  './scss/_handle.scss'
import VueWechatTitle from 'vue-wechat-title'
import isLogin from "./components/common/isLogin";
import store from './store'   //导入store
import dateTime from 'vue-date-time-m';
import tip from './components/Tip/index'
import drag from './public/drag'
import '@vant/touch-emulator'

Vue.use(VueWechatTitle);

Vue.use(Vant)
Vue.use(tip)
Vue.config.productionTip = false
Vue.component('data-time', dateTime);

// 将API方法绑定到全局
Vue.prototype.$http = ajax;   // axios请求设置
Vue.prototype.commonJs = commonJs;   //公共方法申明

const isLoginModule = {
  install: function (Vue) {
    // 创建一个Vue的“子类”组件
    const ToastConstructor = Vue.extend(isLogin)
    // 创建一个该子类的实例,并挂载到一个元素上
    const instance = new ToastConstructor()
    // 将这个实例挂载到动态创建的元素上,并将元素添加到全局结构中
    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)

    // 在Vue的原型链上注册方法，控制组件
    Vue.prototype.$isLogin = (bool) => {
      instance.isLoginBool = bool
    }
  }
}
Vue.use(isLoginModule)
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   store,
//   filters,
//   components: { App },
//   template: '<App/>'
// })

new Vue({
  window: window,
  router,
  store,
  filters,
  drag,
  render: h => h(App),
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js